export const iconFontAwesomeArrowsArrowRightArrowLeft = (
	<i className="fa-solid fa-arrow-right-arrow-left"></i>
);
